import { render, staticRenderFns } from "./KycShow.vue?vue&type=template&id=646c352d"
import script from "./KycShow.vue?vue&type=script&lang=js"
export * from "./KycShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports